import { authApi } from "@/db/api/auth.api";
import { redirect } from "@tanstack/react-router";

interface AuthSuccessResponse {
    [key: string]: any;
}

export const authMiddleware = async (pathname: string): Promise<AuthSuccessResponse | null> => {
    // Skip auth check for public routes
    const publicRoutes = ["/", "/auth/login", "/auth/register"];
    if (publicRoutes.includes(pathname)) {
        return null;
    }

    // Real API mode — auth enforced on all protected routes
    try {
        const response = await authApi.session();
        const user = response.user;

        // Admin Route Guard
        if (pathname.startsWith('/dashboard/admin') && (user as any)?.role !== 'ADMIN') {
            throw redirect({
                to: "/", // Redirect parents away from admin pages
            });
        }

        return response;
    } catch (error: any) {
        if (error.response?.status === 401) {
            throw redirect({
                to: "/auth/login",
                search: { redirect: pathname },
            });
        }

        throw error;
    }
}